exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lowQty[data-v-3233064f]{border-color:red;margin-bottom:1px;cursor:not-allowed}.highQty[data-v-3233064f]{border-color:green;margin-bottom:2px}", ""]);

// exports
